module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Laptop","all":"All","cpu":"CPU","gpu":"GPU","missingSpecs":"Missing specs","improperSpecs":"Improper specs","exportSheet":"Export sheet","importSheet":"Import sheet"}}')
  delete Component.options._Ctor
}
